import React from 'react'

import { Box, Text, Touchable } from '@factorialco/deprecated-design-system'
import { AnimatePresence } from 'framer-motion'
import { CommentsCommentFragment } from 'generated/resources/graphql'

import { ReactionsReactionValues } from 'modules/core/components/Reactions/Reaction'
import i18n from 'modules/core/lib/i18n'

import Comment from 'modules/comments/components/CommentsContainer/Comment'

interface Props {
  previousComments: CommentsCommentFragment[]
  comments: CommentsCommentFragment[]
  totalCount: number
  onShowMore?: () => void
  onAddReaction?: (
    variables: ReactionsReactionValues,
    parentResourceId: number
  ) => Promise<{ id: number } | undefined>
  onDeleteReaction?: (
    id: number,
    parentResourceId: number,
    resourceId: number,
    textCode: string
  ) => Promise<{ success: boolean } | undefined>
}

const FirstAndLastComments = ({
  previousComments,
  comments,
  totalCount,
  onShowMore,
  onAddReaction,
  onDeleteReaction,
}: Props) => {
  const renderedComments = previousComments.length + comments.length
  const loadMoreCommentsCount = totalCount - renderedComments

  return (
    <AnimatePresence initial={false}>
      <>
        {previousComments.length > 0 && (
          <Box gap="s24" paddingBottom="s24">
            {previousComments.map((comment) => (
              <Comment
                key={comment.id}
                comment={comment}
                onAddReaction={onAddReaction}
                onDeleteReaction={onDeleteReaction}
              />
            ))}
          </Box>
        )}
        {loadMoreCommentsCount > 0 && (
          <Touchable onClick={onShowMore}>
            <Box paddingBottom="s24">
              <Text size="200" color="viridian1000" weight="medium">
                {i18n.tp('comments.actions.show_more', { count: loadMoreCommentsCount })}
              </Text>
            </Box>
          </Touchable>
        )}
        {comments.length > 0 && (
          <Box gap="s24" paddingBottom="s24">
            {comments.map((comment) => (
              <Comment
                key={comment.id}
                comment={comment}
                onAddReaction={onAddReaction}
                onDeleteReaction={onDeleteReaction}
              />
            ))}
          </Box>
        )}
      </>
    </AnimatePresence>
  )
}

export default FirstAndLastComments
